import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

function AddPodcastEpisode() {
    const { podcastId } = useParams();
    const navigate = useNavigate();
    const [podcastTitle, setPodcastTitle] = useState('');
    const [episode, setEpisode] = useState({
        episodeNumber: '',
        title: '',
        content: '',
        order: '',
        audioLink: '',
        timingLink: ''
    });

    useEffect(() => {
        const fetchPodcast = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/podcast/${podcastId}`);
                setPodcastTitle(response.data.title || 'پادکست');
            } catch (error) {
                console.error("Error fetching podcast:", error);
                toast.error("خطا در دریافت اطلاعات پادکست");
            }
        };
        fetchPodcast();
    }, [podcastId]);

    const handleChange = (e) => {
        setEpisode({ ...episode, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/podcast-episode`, {
                ...episode,
                podcastId: podcastId,
                episodeNumber: parseInt(episode.episodeNumber),
                order: episode.order ? parseInt(episode.order) : parseInt(episode.episodeNumber)
            });
            if (response.data.success) {
                toast.success('قسمت با موفقیت اضافه شد!');
                setEpisode({
                    episodeNumber: '',
                    title: '',
                    content: '',
                    order: '',
                    audioLink: '',
        timingLink: ''
                });
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error adding episode:", error);
            toast.error('خطا در افزودن قسمت');
        }
    };

    return (
        <>
            <Navbar />
            <div className="container mt-5 mb-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card shadow">
                            <div className="card-header bg-success text-white">
                                <h3 className="mb-0">🎙️ افزودن قسمت جدید به {podcastTitle}</h3>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">شماره قسمت *</label>
                                        <input 
                                            type="number" 
                                            className="form-control" 
                                            name="episodeNumber" 
                                            value={episode.episodeNumber} 
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">عنوان قسمت (اختیاری)</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="title" 
                                            value={episode.title} 
                                            onChange={handleChange} 
                                            placeholder="عنوان قسمت..." 
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">متن قسمت</label>
                                        <textarea 
                                            className="form-control" 
                                            name="content" 
                                            value={episode.content} 
                                            onChange={handleChange} 
                                            rows="5"
                                            placeholder="متن قسمت را وارد کنید..."
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">ترتیب (اختیاری)</label>
                                        <input 
                                            type="number" 
                                            className="form-control" 
                                            name="order" 
                                            value={episode.order} 
                                            onChange={handleChange} 
                                            placeholder="عدد ترتیب..." 
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">🎵 لینک فایل صوتی (اختیاری)</label>
                                        <input 
                                            type="url" 
                                            className="form-control" 
                                            name="audioLink" 
                                            value={episode.audioLink} 
                                            onChange={handleChange} 
                                            placeholder="https://example.com/audio.mp3" 
                                        />
                                    </div>


                                    <div className="mb-3">
                                        <label className="form-label">⏱ لینک JSON تایم‌کد (اختیاری)</label>
                                        <textarea className="form-control" name="timingLink" value={episode.timingLink || ''} onChange={handleChange} rows="4" placeholder="لینک timing.json یا خود JSON تایم‌کد" />
                                        <small className="text-muted">برای دنبال‌کردن دقیق جمله‌ها؛ هر رکورد باید start و end داشته باشد.</small>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <button type="submit" className="btn btn-success">➕ افزودن قسمت</button>
                                        <button type="button" className="btn btn-secondary" onClick={() => navigate(`/podcast/${podcastId}`)}>انصراف</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AddPodcastEpisode;